import React, { createContext, useContext } from 'react';

import { DefaultValues } from 'react-hook-form';
import { FieldValues } from 'react-hook-form/dist/types/fields';

export const FilterContext = createContext<{
  appliedFilters: FieldValues | DefaultValues<FieldValues>;
  setAppliedFilter: (name: string, value: any) => void;
  onReset?: () => void;
}>({
  appliedFilters: {} as FieldValues,
  setAppliedFilter: () => undefined,
});

type Props = {
  children: React.ReactNode;
  appliedFilters: FieldValues | DefaultValues<FieldValues>;
  setAppliedFilter: (name: string, value: any) => void;
  onReset?: () => void;
};

export const FilterContextProvider: React.FC<Props> = ({
  children,
  appliedFilters,
  setAppliedFilter,
  onReset,
}): JSX.Element => {
  return (
    <FilterContext.Provider value={{ setAppliedFilter, appliedFilters, onReset }}>
      {children}
    </FilterContext.Provider>
  );
};

export function useFilterContext() {
  const { appliedFilters, setAppliedFilter, onReset } = useContext(FilterContext);

  return { appliedFilters, setAppliedFilter, onReset };
}
